import { useEvent } from "shared/lib/useEvent"

import {
  TeamScopedCreateMultipleTeamMembersHandler,
  TeamScopedCreateTeamMemberHandler,
  TeamScopedTeamMemberFormHandlers,
  TeamScopedUpdateTeamMemberHandler
} from "../types/TeamScopedTeamMemberFormHandlers"
import { useTeamMemberFormHandlers } from "./useTeamMemberFormHandlers"

export function useTeamScopedTeamMemberFormHandlers(
  teamID: string
): TeamScopedTeamMemberFormHandlers {
  const {
    handleCreateTeamMember,
    handleCreateMultipleTeamMembers,
    handleUpdateTeamMember
  } = useTeamMemberFormHandlers()

  const teamScopedCreateTeamMember: TeamScopedCreateTeamMemberHandler =
    useEvent(formData => {
      return handleCreateTeamMember({ formData, teamID })
    })

  const teamScopedCreateMultipleTeamMembers: TeamScopedCreateMultipleTeamMembersHandler =
    useEvent(formData => {
      return handleCreateMultipleTeamMembers({ formData, teamID })
    })

  const teamScopedUpdateTeamMember: TeamScopedUpdateTeamMemberHandler =
    useEvent(({ teamMemberID, updates }) => {
      return handleUpdateTeamMember({ teamID, teamMemberID, updates })
    })

  return {
    handleCreateTeamMember: teamScopedCreateTeamMember,
    handleCreateMultipleTeamMembers: teamScopedCreateMultipleTeamMembers,
    handleUpdateTeamMember: teamScopedUpdateTeamMember
  }
}
